import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";

import { ExecutionPanelHeader } from "@src/features/ai/components/WorkflowEditor/execution/panel/header/ExecutionPanelHeader";

export const AtlasRailHeader = () => (
  <Stack sx={{ flexShrink: 0, gap: 3, width: "100%" }}>
    <ExecutionPanelHeader sx={{ height: 38, px: 0 }} />
    <Divider
      sx={{
        borderColor: (theme) => theme.igBorders.core.default,
        mt: "-1px",
      }}
    />
  </Stack>
);
